export const goldPrices = [
  { code: "XAU/USD", name: "伦敦金现", price: "2638.42", change: 0.86, high: "2651.10", low: "2612.75" },
  { code: "AU9999", name: "上海金Au99.99", price: "612.35", change: 0.42, high: "615.80", low: "608.20" },
  { code: "XAU/CNY", name: "人民币金价", price: "618.66", change: -0.18, high: "622.40", low: "615.10" },
  { code: "XAG/USD", name: "伦敦银现", price: "31.24", change: 1.32, high: "31.68", low: "30.41" },
  { code: "GC=F", name: "COMEX黄金", price: "2651.80", change: 0.55, high: "2664.20", low: "2630.50" },
  { code: "AU2312", name: "沪金主力", price: "615.92", change: -0.24, high: "620.30", low: "612.60" },
];